var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-pagination',_vm._b({attrs:{"value":_vm.value,"total-rows":_vm.total,"per-page":_vm.perPage,"aria-controls":"donors-table"},on:{"input":function($event){return _vm.$emit('input', $event)}}},'b-pagination',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }